export default __webpack_public_path__ + "static/media/kontakt.d6de95b3.png";